<template>
  <div class="iframe-container-box">
    <div class="searchForm">
      <renderForm :formData.sync="searchForm" :list="ruleForm" ref="ruleFormRef">
          <template v-slot:operation>
              <rs-button v-if="$btnResource()['XTSZ-RZGL-DLRZ-CY']" type="primary" @click="handleSearch">查询</rs-button>
              <rs-button v-if="$btnResource()['XTSZ-RZGL-YWRZ-DC']" type="primary" @click="logout">导出</rs-button>
              <rs-button type="text"  @click="clear">清除条件</rs-button>            
          </template>
      </renderForm>
    </div>
    <!-- 表格 -->
    <div class="resultContent">
      <renderTable highlight-current-row class="my-table" :list="tableData" :columns="tableColumns" border></renderTable>
    </div>
    <rs-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 200, 300, 400]" :page-size="pageSize" background :prev-text="'上一页'" :next-text="'下一页'" layout="prev, pager, next, sizes, jumper" :total="total"></rs-pagination>
  </div>
</template>
<script>
import Utils from '@/utils/utils'
import API from '@/api/api'
let tableColumns = [
    {
      width: 60,
      type: "index",
      fixed: true,
      label: '序号',
      align: "left"
    },
    {
      prop: "loginName",
      label: "登录名",
      maxWidth: "80px",
      align: "left",
      width: 120,
    },
    {
      prop: "loginSource",
      label: "登录来源",
      maxWidth: "80px",
      align: "left",
      width: 120,
    },
    {
      prop: "operateContent",
      label: "操作内容",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "operateDetail",
      label: "操作详情",
      maxWidth: "80px",
      align: "left",
      width:200
    },
    {
      prop: "remark",
      label: "结果",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "operateTime",
      label: "操作时间",
      maxWidth: "80px",
      align: "left",
      width: 200,
    },
    {
      prop: "ipAddress",
      label: "ip地址",
      maxWidth: "80px",
      align: "left",
      width: 230,
    },
    {
      prop: "country",
      label: "国家",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "languages",
      label: "语言",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "deviceType",
      label: "设备类型",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "os",
      label: "操作系统",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "osVersion",
      label: "系统版本",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "browser",
      label: "浏览器",
      maxWidth: "80px",
      align: "left",
      width: 100,
    },
    {
      prop: "browserVersion",
      label: "浏览器版本",
      maxWidth: "80px",
      align: "left",
      width: 130,
    },
    {
      prop: "pageUrl",
      label: "被访问页面的url",
      maxWidth: "80px",
      align: "left", 
    },

]
let ruleForm = [
  {
    type: "input",
    label: "登录名",
    key: "loginName"
  },
  {
    type: "input",
    label: "操作详情",
    key: "operateDetail"
  },
  {
    type: "datetime",
    label: "开始时间",
    "value-format": "yyyy/MM/dd HH:mm:ss",
    key: "operateTimeStart"    
  },
  {
    type: "datetime",
    label: "结束时间",
    "value-format": "yyyy/MM/dd HH:mm:ss",
    key: "operateTimeEnd"    
  },  
  {
    slot: "operation"
  }
]

export default {
  data(){
    return {
      tableData:[],
      pageSize:10,
      total:0,
      pageNum:1,
      tableColumns:tableColumns,
      searchForm:{
        loginName:'',
        operateDetail:'',
        operateTimeStart:'',
        operateTimeEnd:'',
        signDate:[]
      },
      ruleForm:ruleForm
    }
  },
  created(){
    this.getData();
  },
  methods:{
    async getData(){
      let params={
        pageNum:this.pageNum,
        pageSize:this.pageSize,
        ...this.queryparams()
      }
      let data = await API.querySysLogList(params);  
      this.tableData = data.data.data.list
      this.total = data.data.data.total
    },
    queryparams(){
      let {userName,userCode} = Utils.getSession('userInfo')
      return {
        operateCode:userCode,
        operateName:userName,
        loginName:this.searchForm.loginName,
        operateDetail:this.searchForm.operateDetail,
        operateTimeStart:this.searchForm.operateTimeStart,
        operateTimeEnd:this.searchForm.operateTimeEnd,
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getData();
    },
    handleSearch(){
      this.pageNum=1;
      this.getData();
    },
    clear(){
      this.searchForm.loginName = '';
      this.searchForm.operateDetail = '';
      this.searchForm.operateTimeStart = '';
      this.searchForm.operateTimeEnd = '';  

    },
    logout(){
      if(this.tableData.length==0)
        this.$message.error('不能导出空数据')
      else
        API.exportSysLog(this.queryparams()).then(res =>{
          this.$message.success('导出成功，请至下载中心下载！')
        })      
    }
  }
}
</script>
<style lang="less" scoped>

</style>